/**
 * The one HTTP access point behind the app's fetchers. Pure — no React, no env,
 * no router. Owns the bearer header, the ok/json path, and unified error
 * handling: 401/403 invokes `onUnauthorized` (the caller's redirect) and then,
 * like every other non-ok status, throws so the failure cannot be silently
 * swallowed downstream.
 */
export async function request<T>(
  url: string,
  { token, onUnauthorized }: { token?: string; onUnauthorized?: () => void } = {}
): Promise<T> {
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.ok) return res.json();

  if (res.status === 401 || res.status === 403) {
    onUnauthorized?.();
  }

  throw new Error(`Request to ${url} failed with status ${res.status}`);
}
